module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integrations-container"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-xs-9 integrations-header"
  }, [_vm._v("\n      You can connect Parlay to any of the following LMS / SIS tools. These\n      will allow you to roster teachers, students, and courses. For the LMSs,\n      teachers will also be able to roster their classes, connect assignments,\n      and sync assessment data and feedback.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('pl-button', {
    staticClass: "w-100 b",
    class: [_vm.enableIntegrations ? 'enable-integrations' : 'pl-primary'],
    staticStyle: {
      "font-size": "20px",
      "min-height": "45px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUpIntegrations.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        ENABLE INTEGRATIONS\n        "), (_vm.enableIntegrations) ? _c('i', {
    staticClass: "fa fa-check ml4",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('pl-button', {
    staticClass: "w-100 b pl-primary",
    staticStyle: {
      "font-size": "20px",
      "min-height": "45px"
    },
    attrs: {
      "disabled": !_vm.enableIntegrations
    },
    nativeOn: {
      "click": function($event) {
        return _vm.manageIntegrations.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        MANAGE INTEGRATIONS\n      ")])], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_c('integrations-table', {
    attrs: {
      "providers": _vm.providers
    },
    on: {
      "import_courses_modal": _vm.getEdlinkSchoolIntegrationTeachers,
      "add_integration_id": _vm.getEdlinkProviders
    }
  })], 1), _vm._v(" "), (_vm.import_courses_modal) ? _c('integrations-teachers-modal', {
    attrs: {
      "teachers": _vm.teachers,
      "selectedTeachers": _vm.selectedTeachers,
      "integration_id": _vm.integration_id,
      "integration_name": _vm.integration_name,
      "loading_data": _vm.loading_data
    },
    on: {
      "filters": _vm.searchAndFilters,
      "admin-portal-filter-changed": _vm.resetFilters,
      "scroll-on-table": _vm.handleScroll,
      "close": _vm.resetCourses,
      "load_edlink_courses": _vm.getEdlinkSchoolIntegrationTeachers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5c55b538!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/integrations/adminPortalIntegrations.vue
// module id = 2126
// module chunks = 61